import { getNumberRangeData } from '../components/AttachPbxContent/attachPbxUtils.js';
import {
  AuthenticatedUserRole,
  ChangeRequestStatus,
  InvitationProfileEnum,
  SearchResultType,
  SubscriptionType,
} from '../generated/api/models.js';
import { SalesType } from '../generated/api/salesType.js';
import {
  activateOmalaskuPrivateMethod,
  authorizeExternalAuthorizationRequestPublicMethod,
  cancelInvitationPrivateMethod,
  cancelOmalaskuPrivateMethod,
  changeOwnerAccountPrivateMethod,
  changeSubscriptionBillingAccountPrivateMethod,
  changeSubscriptionChangeSimPrivateMethod,
  changeSubscriptionFeaturesPrivateMethod,
  changeSubscriptionMobilePbxPrivateMethod,
  checkSsoUserExistsPublicMethod,
  createAnonymousLeadPublicMethod,
  createAnonymousSupportCasePublicMethod,
  createBillingAccountCocoPrivateMethod,
  createBillingAccountPrivateMethod,
  createContactPrivateMethod,
  createDnsRecordPrivateMethod,
  createDraftCatalogPrivateMethod,
  createEmployeePersonBillingAccountPrivateMethod,
  createEmployeeProductListPrivateMethod,
  createEmployeeProductSelectionPrivateMethod,
  createInvitationPrivateMethod,
  createLeadPrivateMethod,
  createOnlineOrderPrivateMethod,
  createProductOrderPrivateMethod,
  createShoppingCartPrivateMethod,
  createSupportCasePrivateMethod,
  createVirtualCatalogPrivateMethod,
  deleteDnsRecordPrivateMethod,
  deleteDraftCatalogPrivateMethod,
  deleteEmployeeProductListPrivateMethod,
  deleteEmployeeProductSelectionPrivateMethod,
  deleteOpenFormDraftsPrivateMethod,
  deprecateVirtualCatalogPrivateMethod,
  domainGetPublicMethod,
  elisaIdV2LogOutPrivateMethod,
  enableMfaPrivateMethod,
  finalizeShoppingCartPrivateMethod,
  generateNumbersPrivateMethod,
  generateReportPrivateMethod,
  getAccountKeyUsersByServiceAgreementIdPrivateMethod,
  getAddOnRulesPublicMethod,
  getAddOnVisibilityPrivateMethod,
  getAddOnVisibilityPublicMethod,
  getAvailableInstallationDatesPrivateMethod,
  getBillChannelsPublicMethod,
  getBillingAccountByIdCocoPrivateMethod,
  getBillingAccountScheduledChangePrivateMethod,
  getBillingAccountsCocoPrivateMethod,
  getBillingAccountsPrivateMethod,
  getCampaignsPublicMethod,
  getChangeRequestDetailsPrivateMethod,
  getChatSchedulePublicMethod,
  getContactBillingAccountsPrivateMethod,
  getContactInvitationPrivateMethod,
  getContactsPrivateMethod,
  getContractsPrivateMethod,
  getCustomerOrderAdditionalInfoPrivateMethod,
  getCustomerOrdersPrivateMethod,
  getCustomerPrivateMethod,
  getDeliveryMethodsPrivateMethod,
  getDeliveryOptionsPrivateMethod,
  getDeviceVariantsPrivateMethod,
  getDnsRecordHistoryPrivateMethod,
  getDnsRecordsHistoryPrivateMethod,
  getDnsRecordsPrivateMethod,
  getDocumentsPrivateMethod,
  getEligibleProductOffersForOfferTypePublicMethod,
  getEmployeeOnlineModelHeadersPrivateMethod,
  getEmployeeOnlineModelPrivateMethod,
  getEmployeeProductListPrivateMethod,
  getEmployeeProductListsPrivateMethod,
  getEmployeeProductSelectionPrivateMethod,
  getEmployeeProductSelectionsPrivateMethod,
  getExternalAuthenticationMethodsPublicMethod,
  getExternalAuthorizationRequestPublicMethod,
  getGeneratedReportPrivateMethod,
  getGeographicAddressByIdPrivateMethod,
  getGeographicAddressPrivateMethod,
  getHolidaysPublicMethod,
  getIdeatArticleV3PublicMethod,
  getIdeatArticlesV3PublicMethod,
  getIdeatCategoryV3PublicMethod,
  getIdeatHomepageConfigV3PublicMethod,
  getIdeatKeywordsV3PublicMethod,
  getIdeatTagV3PublicMethod,
  getInvitationPublicMethod,
  getInvoicesPrivateMethod,
  getLicenseManagementAccountsPrivateMethod,
  getMfaDetailsPrivateMethod,
  getMonthlyUsageDetailsPrivateMethod,
  getMyselfAccountPrivateMethod,
  getMyselfSecondaryAccountsCompanyInfosPrivateMethod,
  getMyselfSecondaryAccountsPrivateMethod,
  getNavigationV3PublicMethod,
  getNumberRangePrivateMethod,
  getOmalaskuStatusPrivateMethod,
  getOnboardingRequestsPrivateMethod,
  getOnlineModelByCodeV3PublicMethod,
  getOnlineModelHeadersV3PublicMethod,
  getOnlineModelsByAddressPublicMethod,
  getOpenFormAccountPrivateMethod,
  getOpenFormContactDetailsPrivateMethod,
  getOpenFormDraftItemListPrivateMethod,
  getOpenFormDraftPrivateMethod,
  getOpenFormItemListPrivateMethod,
  getOpenFormPrivateMethod,
  getOpenFormProductAvailabilityPrivateMethod,
  getOpenFormSummaryPrivateMethod,
  getOpenSupportCasesPrivateMethod,
  getOrderByIdPrivateMethod,
  getOrderConfirmationPdfPrivateMethod,
  getOrdersPrivateMethod,
  getPageV3PublicMethod,
  getPrivateOnlineModelHeadersPrivateMethod,
  getPrivateOnlineModelPrivateMethod,
  getProductDeliveryMethodsPrivateMethod,
  getProductOfferingByIdPublicMethod,
  getProductOffersByOfferIdPublicMethod,
  getProposalByIdPrivateMethod,
  getProposalsPrivateMethod,
  getPunchoutOnlineModelHeadersPrivateMethod,
  getPunchoutOnlineModelPrivateMethod,
  getRelatedOffersPublicMethod,
  getReportsPrivateMethod,
  getSearchBillingAccountsV3PrivateMethod,
  getSearchContactsV3PrivateMethod,
  getSearchCustomerOrdersV3PrivateMethod,
  getSearchEmployeeCustomerOrdersV3PrivateMethod,
  getSearchGlobalV3PrivateMethod,
  getSearchInvoiceDocumentsV3PrivateMethod,
  getSearchInvoicesV3PrivateMethod,
  getSearchOpenSupportCasesV3PrivateMethod,
  getSearchSubscriptionActionsV3PrivateMethod,
  getSearchSubscriptionAggregationsV3PrivateMethod,
  getSearchSubscriptionsV3PrivateMethod,
  getSearchSupportCasesV3PrivateMethod,
  getSearchVirtualCatalogsV3PrivateMethod,
  getServiceAgreementsPrivateMethod,
  getSubscriptionActionsPrivateMethod,
  getSubscriptionAggregationsPrivateMethod,
  getSubscriptionPrivateMethod,
  getSubscriptionScheduledChangePrivateMethod,
  getSubscriptionsPrivateMethod,
  getSupportCaseHistoryPrivateMethod,
  getSupportCasePrivateMethod,
  getSupportCasesPrivateMethod,
  getTrainingPublicMethod,
  getUserCustomerOrdersPrivateMethod,
  getVaihtoetuGradingFormPublicMethod,
  getVaihtoetuItemGroupsPublicMethod,
  getVaihtoetuManufacturersPublicMethod,
  getVaihtoetuModelsPublicMethod,
  getVirtualCatalogPrivateMethod,
  getVirtualCatalogsPrivateMethod,
  getWarrantyReceiptPdfPrivateMethod,
  globalSearchPrivateMethod,
  hasPendingActionsForContactPrivateMethod,
  hasPendingSubscriptionActionsPrivateMethod,
  identifyStronglyPrivateMethod,
  initCardPaymentForProductOrderPrivateMethod,
  licenseManagementUrlPrivateMethod,
  listInvitationsPrivateMethod,
  loginWithAccountCommunityUserPrivateMethod,
  maintenanceEppPrivateMethod,
  migrateUsersPrivateMethod,
  mobileVerificationRequestPrivateMethod,
  parameterizedSearchContactsPrivateMethod,
  patchEmployeeProductListPrivateMethod,
  patchEmployeeProductSelectionPrivateMethod,
  postContractPrivateMethod,
  postCreateInterworksAccountPrivateMethod,
  postFilePrivateMethod,
  postOpenFormCustomerNeedPrivateMethod,
  postOpenFormDraftPrivateMethod,
  postScheduledBillingAccountChangePrivateMethod,
  postServiceFeePrivateMethod,
  postTerminateContractPrivateMethod,
  prepareElisaIdV2LoginPublicMethod,
  publishDraftCatalogPrivateMethod,
  putScheduledBillingAccountChangePrivateMethod,
  putSubscriptionScheduledChangePrivateMethod,
  raiseAuthenticationLevelPrivateMethod,
  raiseAuthenticationLevelValidateOtpPrivateMethod,
  redeemOrTerminateEppPrivateMethod,
  registerExternalAuthenticationUserPublicMethod,
  registerUserPrivateMethod,
  replaceVirtualCatalogsPrivateMethod,
  requestEmailVerificationPrivateMethod,
  resendEmailVerificationPrivateMethod,
  resendInvitationPrivateMethod,
  reviewAsEmployerPrivateMethod,
  searchAddressPrivateMethod,
  searchCompaniesPublicMethod,
  searchCompaniesV3PrivateMethod,
  searchForPickupPointPrivateMethod,
  startBbfPrivateMethod,
  startMfPrivateMethod,
  submitMoveContactPrivateMethod,
  submitProductOrderPrivateMethod,
  submitVaihtoetuPriceQuotePublicMethod,
  updateAccountKeyUserPrivateMethod,
  updateBillingAccountPrivateMethod,
  updateContactAccessRightsPrivateMethod,
  updateContactPrivateMethod,
  updateDnsRecordPrivateMethod,
  updateDraftCatalogPrivateMethod,
  updateEmployeePersonBillingAccountPrivateMethod,
  updateMyselfAccountPrivateMethod,
  updateProductOrderDeliveryMethodPrivateMethod,
  updateProductOrderPrivateMethod,
  updateProposalByIdPrivateMethod,
  updateShoppingCartPrivateMethod,
  validateAvailabilityOfNumbersPrivateMethod,
  validateExternalAuthenticationUserAuthorityPublicMethod,
  validateMoveContactPrivateMethod,
  validatePublicMethod,
  verifyEmailVerificationAndProcessInvitationPrivateMethod,
  verifyEmailVerificationPrivateMethod,
  verifyMobileVerificationPrivateMethod,
} from '../generated/api/uiApiMethods.js';
import { getSubscriptionTypes } from '../public/common/util/category.js';
import { getFeatureFlags } from '../public/site/configStore.js';
import { getActiveAccountMasterId } from '../selfservice/common/localStorageUtils.js';
import { getPortal, isEoe, isPunchoutPath } from './constants/pathVariables.js';
import { AddOnVisibilityOperationType, ModelType, PRODUCT_LIST_ACTION_HEADER } from './enums.js';
import { Locale, getLocale, resolveLocaleFromPath } from './i18n';
import { emptyAddOnRulesResponse } from './utils/addOnRulesUtils.js';
import { convertToCommonErrors } from './utils/errorUtils.js';
import { isStrictFeatureEnabled } from './utils/featureFlagUtils.js';
import { isInBrowser } from './utils/ssrUtils.js';
import { createRedirectURL } from './utils/urlUtils.js';
import type { DeviceListActionCoCo, DeviceVariantProductTypeCoCo, OfferType, SubscriptionCategory } from './enums.js';
import type { NumberRangeData } from './loaders.js';
import type {
  AvailableInstallationDatesRequestItem,
  AvailableInstallationDatesResponseItem,
} from './types/installationDatesCoCo.js';
import type { UpsertPersonBillingAccountRequest } from './utils/billingAccountUtils.js';
import type { ContactSupportInfo } from '../components/ContactSupportForm/index.js';
import type { DnsRecordsRequestQuery } from '../components/DnsManagement/dnsManagementUtils.js';
import type { MobileOtpSelfRegistrationResponse } from '../components/EoeSelfRegistration/EoeSelfRegistration.js';
import type { OmalaskuStatusWithMsisdnResponse } from '../components/Omalasku/omalaskuUtils.js';
import type { SubscriptionsDeviceMultiFilter } from '../components/SubscriptionLists/SubscriptionTable.js';
import type { AuthenticationResult } from '../generated/api/authenticationResult.js';
import type { BillingAccountCoco } from '../generated/api/billingAccountCoco.js';
import type { BillingAccountCreateRequestCoco } from '../generated/api/billingAccountCreateRequestCoco.js';
import type { ChatScheduleResponse } from '../generated/api/chatScheduleResponse.js';
import type { CocoProductOrderDetail } from '../generated/api/cocoProductOrderDetail.js';
import type { CocoProductOrderSummary } from '../generated/api/cocoProductOrderSummary.js';
import type { CommercialAddonProductOfferingsResponse } from '../generated/api/commercialAddonProductOfferingsResponse.js';
import type { ContactAccessRightsUpdateRequest } from '../generated/api/contactAccessRightsUpdateRequest';
import type { ContactInvitation } from '../generated/api/contactInvitation';
import type { CustomerResponse } from '../generated/api/customerResponse.js';
import type { DeliveryMethodGroup } from '../generated/api/deliveryMethodGroup.js';
import type { DeliveryOptionsResponse } from '../generated/api/deliveryOptionsResponse.js';
import type { DeviceVariantGroup } from '../generated/api/deviceVariantGroup.js';
import type { EmailVerificationRequest } from '../generated/api/emailVerificationRequest.js';
import type { EmployeeProductListRequest } from '../generated/api/employeeProductListRequest.js';
import type { EmployeeProductListResponse } from '../generated/api/employeeProductListResponse.js';
import type { EmployeeProductSelectionRequest } from '../generated/api/employeeProductSelectionRequest.js';
import type { EmployeeProductSelectionResponse } from '../generated/api/employeeProductSelectionResponse.js';
import type { GeographicAddress } from '../generated/api/geographicAddress.js';
import type { GetServiceAgreementsResponse } from '../generated/api/getServiceAgreementsResponse';
import type { IdeatArticleResponse } from '../generated/api/ideatArticleResponse.js';
import type { IdeatArticlesResponse } from '../generated/api/ideatArticlesResponse.js';
import type { IdeatHomepageConfigResponse } from '../generated/api/ideatHomepageConfigResponse.js';
import type { IdeatKeywordsResponse } from '../generated/api/ideatKeywordsResponse.js';
import type { InitCardPaymentResponse } from '../generated/api/initCardPaymentResponse.js';
import type { Invitation } from '../generated/api/invitation.js';
import type { MigrateUserRequest } from '../generated/api/migrateUserRequest.js';
import type { MigrateUsersResponse } from '../generated/api/migrateUsersResponse.js';
import type { MobileVerificationRequest } from '../generated/api/mobileVerificationRequest.js';
import type {
  AccountKeyUsersResponse,
  AddOnRulesResponse,
  AddOnVisibilityResponse,
  AdminAddressSearchResponse,
  AdminInvitation,
  AuthenticationMethod,
  AuthorizationRequest,
  BillingAccount,
  BillingAccountScheduledChangeResponse,
  BillingAccountScheduledChangeState,
  BillingAccountsResponse,
  CampaignsResponse,
  Catalog,
  ChangeMobileSimParameters,
  ChangeRequestDetails,
  CheckUserExistsRequest,
  CheckUserExistsResponse,
  CompanyInfoResponse,
  Contact,
  ContactsResponse,
  Contract,
  ContractRequest,
  ContractsResponse,
  CreateInterworksAccountRequest,
  CustomerOrderAdditionalInfo,
  CustomerOrdersResponse,
  DeliveryMethodsResponse,
  DnsRecordRequest,
  DnsRecordsHistoryResponse,
  DnsRecordsResponse,
  ElisaIdV2LogoutResponse,
  EmployeeInvitation,
  GetSubscriptionScheduledChanges,
  HolidaysResponse,
  InvitationLanding,
  InvoiceDocumentsResponse,
  InvoicesResponse,
  LicenseManagementAccount,
  MfaDetailsResponse,
  MonthlyUsageDetailsResponse,
  MoveContactPendingActionsResponse,
  MoveContactRequest,
  MoveContactResponse,
  MoveContactValidateRequest,
  MoveContactValidateResponse,
  NewNumbersResponse,
  OFProductAvailability,
  OFReferenceNumber,
  OFReferenceNumbers,
  OmalaskuActivationRequest,
  OnboardingRequestsResponse,
  OnlineModel,
  OnlineModelHeader,
  OnlineModelsResponse,
  OnlineOrder,
  OpenFormAccountResponse,
  OpenFormContactDetailsResponse,
  OpenFormCustomerNeedRequest,
  OpenFormDraft,
  OpenFormDraftItem,
  OpenFormDraftUpsert,
  OpenFormListResponse,
  OpenFormResponse,
  OpenFormSummaryResponse,
  PageResponse,
  ParameterizedSearchContactResults,
  PickupPointSearchResponse,
  PostAnonymousLeadRequest,
  PostEppMaintenanceRequest,
  PostEppRedeemTerminateRequest,
  PostFileResponse,
  PostLeadRequest,
  PostReviewRequest,
  PrepareElisaIdV2LoginResponse,
  PutBillingAccountResponse,
  PutSupportCaseResponse,
  PutVirtualCatalogResponse,
  RegisterUserRequest,
  ReportItemResponse,
  ReportType,
  SecondaryAccount,
  SecondaryAccountCompanyInfo,
  ServiceFeeRequest,
  ServiceFeeResponse,
  ShoppingCart,
  ShoppingCartResponse,
  StartFixerResponse,
  Subscription,
  SubscriptionActionsResponse,
  SubscriptionAggregationsResponse,
  SubscriptionChangeFeaturesRequest,
  SubscriptionChangeOwnerAccountRequest,
  SubscriptionPbxConfiguration,
  SubscriptionScheduledChangeUpdateResponse,
  SubscriptionsResponse,
  SupportCase,
  SupportCaseDetails,
  SupportCasesResponse,
  TrainingResponse,
  UpdateAccountKeyUserRequest,
  UpdateAccountRequest,
  VaihtoetuGradingForm,
  VaihtoetuItemGroupList1,
  VaihtoetuManufacturerList,
  VaihtoetuModelList,
  VaihtoetuPriceQuoteRequest,
  VaihtoetuPriceQuoteResponse,
  ValidateAvailabilityOfNumbersRequest,
  ValidateAvailabilityOfNumbersResponse,
  ValidateUserAuthorityRequest,
  ValidateUserAuthorityResponse,
  VirtualCatalogReplaceRequest,
  VirtualCatalogReplaceResponse,
  VirtualCatalogResponse,
} from '../generated/api/models.js';
import type { NavigationResponse } from '../generated/api/navigationResponse.js';
import type { PatchEmployeeProductListRequest } from '../generated/api/patchEmployeeProductListRequest.js';
import type { PatchEmployeeProductSelectionRequest } from '../generated/api/patchEmployeeProductSelectionRequest.js';
import type { PostOnlineOrderResponse } from '../generated/api/postOnlineOrderResponse';
import type { ProductOfferingsResponse } from '../generated/api/productOfferingsResponse';
import type { ProductOrderDeliveryMethodRequest } from '../generated/api/productOrderDeliveryMethodRequest.js';
import type { ProductOrderDeliveryMethodResponse } from '../generated/api/productOrderDeliveryMethodResponse.js';
import type { ProductOrderRequest } from '../generated/api/productOrderRequest';
import type { ProductOrderResponse } from '../generated/api/productOrderResponse';
import type { ProposalResponse } from '../generated/api/proposalResponse';
import type { RegisterIndividualRequest } from '../generated/api/registerIndividualRequest';
import type { ApiMethod, LimitableQuery, SortableLimitableQuery } from '../generated/api/uiApiMethods.js';
import type { UpdateProductOrderRequest } from '../generated/api/updateProductOrderRequest.js';
import type { UpdateProposalRequest } from '../generated/api/updateProposalRequest';
import type { UpdateProposalResponse } from '../generated/api/updateProposalResponse';
import type { VerifyEmailVerificationProcessInvitationRequest } from '../generated/api/verifyEmailVerificationProcessInvitationRequest.js';
import type { VerifyEmailVerificationRequest } from '../generated/api/verifyEmailVerificationRequest.js';
import type { VerifyMobileVerificationRequest } from '../generated/api/verifyMobileVerificationRequest.js';
import type { LoaderFunctionArgs } from 'react-router';

export interface CustomerOrdersQuery extends SortableLimitableQuery {
  search?: string;
  status?: string;
  useSearchService?: boolean;
  customerOrderDisplayId?: string;
  changeRequestId?: string;
  customerOrderType?: string;
  onlySfdcOrders?: boolean;
  productType?: string;
}

export interface SupportCasesQuery extends SortableLimitableQuery {
  search?: string;
  feature?: string;
  status?: string;
}

export interface VirtualCatalogsQuery extends SortableLimitableQuery {
  search?: string;
  searchAllAccounts?: boolean;
  useSearchService?: boolean;
}

export interface BillingAccountsQuery extends SortableLimitableQuery {
  useSearchService?: boolean;
  search?: string;
  sourceSystem?: string;
  billingContactId?: string;
}

export interface SubscriptionActionsQuery extends SortableLimitableQuery {
  own?: boolean;
  search?: string;
  useSearchService?: boolean;
  subscriptionActionDisplayId?: string;
}

export interface InvoicesQuery extends SortableLimitableQuery {
  balanceRange?: string;
  search?: string;
  useSearchService?: boolean;
  category?: string;
  openInvoicesOnly?: boolean;
  paidInvoicesOnly?: boolean;
}

export interface InvoiceDocumentsQuery extends SortableLimitableQuery {
  useSearchService?: boolean;
  search?: string;
}

const isSearchApiV3Enabled = () => isStrictFeatureEnabled(getFeatureFlags().searchApiV3Ff);

interface CallUiApiOpts {
  body?: BodyInit;
  headers?: HeadersInit;
  signal?: AbortSignal;
  mdmId?: string;
  useDefaultMdmId?: boolean;
  noThrow?: boolean;
  jsonContent?: boolean;
  isEmployee?: boolean;
  isPunchout?: boolean;
  redirect?: RequestRedirect;
}

export const callUiApi = async (apiCall: ApiMethod, opts?: CallUiApiOpts) => {
  const {
    body,
    signal,
    useDefaultMdmId = true,
    noThrow = false,
    jsonContent = true,
    isEmployee = false,
    isPunchout = false,
  } = opts ?? {};
  const { path, verb: method } = apiCall;
  const mdmId = opts?.mdmId ?? (useDefaultMdmId ? getActiveAccountMasterId() : undefined);
  const userRole = isEmployee
    ? AuthenticatedUserRole.EMPLOYEE
    : isPunchout
      ? AuthenticatedUserRole.PUNCHOUT_USER
      : undefined;
  const headers = {
    ...{ 'Accept-Language': getLocale() }, // eslint-disable-line @typescript-eslint/naming-convention
    ...(jsonContent ? { 'Content-Type': 'application/json' } : {}), // eslint-disable-line @typescript-eslint/naming-convention
    ...(mdmId ? { 'X-API-Account-Master-ID': mdmId } : {}), // eslint-disable-line @typescript-eslint/naming-convention
    ...(mdmId ? { 'X-Elisa-Company-MDM-ID': mdmId } : {}), // eslint-disable-line @typescript-eslint/naming-convention
    ...(userRole ? { 'X-API-User-Role': userRole } : {}), // eslint-disable-line @typescript-eslint/naming-convention
  };

  const rawEntries = !opts?.headers
    ? []
    : opts.headers instanceof Headers || Array.isArray(opts.headers)
      ? Array.from(opts.headers)
      : Object.entries(opts.headers);
  const protectedHeaders = new Set(Object.keys(headers).map(name => name.toLowerCase()));
  const forwardedHeaders = Object.fromEntries(rawEntries.filter(([name]) => !protectedHeaders.has(name.toLowerCase())));
  const init = {
    body,
    method,
    headers: { ...forwardedHeaders, ...headers },
    signal,
    redirect: opts?.redirect,
  };
  const res = await fetch(path, init);

  if (noThrow || res.ok) {
    return res;
  } else {
    throw res;
  }
};

const callUiApiForEmployee = async (apiCall: ApiMethod, opts?: CallUiApiOpts) => {
  return await callUiApi(apiCall, { ...opts, isEmployee: true });
};

const callUiApiForPunchout = async (apiCall: ApiMethod, opts?: CallUiApiOpts) => {
  return await callUiApi(apiCall, { ...opts, isPunchout: true });
};

/**
 * Create only functions in this file that call fetch and use functions from uiApiMethods
 * Do not call these functions inside Epics
 * Do not mix fetch usages with redux usages
 */

export const fetchCompanyList = async (query: string) => {
  const apiCall = isSearchApiV3Enabled()
    ? searchCompaniesV3PrivateMethod({ query })
    : searchCompaniesPublicMethod({ query });
  return (await (await callUiApi(apiCall)).json()).result;
};

export const fetchTrainings = async (query: string): Promise<TrainingResponse> => {
  return (await callUiApi(getTrainingPublicMethod(query))).json();
};

export const fetchChatSchedule = async (opts?: CallUiApiOpts): Promise<ChatScheduleResponse> => {
  return (await callUiApi(getChatSchedulePublicMethod(), { ...opts, useDefaultMdmId: false })).json();
};

export const fetchInvitation = async (
  invitationId: string,
  opts?: CallUiApiOpts
): Promise<InvitationLanding | undefined> => {
  const res = await callUiApi(getInvitationPublicMethod(invitationId), {
    ...opts,
    useDefaultMdmId: false,
    noThrow: true,
  });
  // expired/nonexistent invitation, not an unexpected error
  if (res.status === 404) {
    return undefined;
  }
  if (!res.ok) {
    throw res;
  }
  return res.json();
};

export const fetchContactInvitation = async (contactMasterId: string): Promise<ContactInvitation | undefined> => {
  const response = await callUiApi(getContactInvitationPrivateMethod(contactMasterId));
  if (response.headers.get('Content-Type')?.includes('application/json')) {
    return await response.json();
  }
  return undefined;
};

export const fetchServiceAgreements = async (ssoId: string): Promise<GetServiceAgreementsResponse> => {
  return (await callUiApi(getServiceAgreementsPrivateMethod({ ssoId }))).json();
};

export const migrateUsers = async (request: MigrateUserRequest): Promise<MigrateUsersResponse> => {
  return (
    await callUiApi(migrateUsersPrivateMethod(), {
      body: JSON.stringify(request),
    })
  ).json();
};

export const createAdminInvitation = (adminInvitation: AdminInvitation, contactPrimaryMasterId?: string) => {
  return callUiApi(createInvitationPrivateMethod(), {
    body: JSON.stringify({ profile: InvitationProfileEnum.CUSTOMER_ADMIN, adminInvitation }),
    mdmId: contactPrimaryMasterId,
  });
};

export const fetchAddressSearch = async (
  query: { query: string; postalCode: string },
  opts?: CallUiApiOpts
): Promise<AdminAddressSearchResponse> => {
  return (await callUiApi(searchAddressPrivateMethod(query), opts)).json();
};

export const fetchOpenFormAccount = async (opts?: CallUiApiOpts): Promise<OpenFormAccountResponse> => {
  return (await callUiApi(getOpenFormAccountPrivateMethod(), opts)).json();
};

export const fetchOpenFormProductAvailability = async (
  query: { addressId: string; formId: string; subscriptionTypes: string[] },
  opts?: CallUiApiOpts
): Promise<OFProductAvailability[]> => {
  return (await callUiApi(getOpenFormProductAvailabilityPrivateMethod(query), opts)).json();
};

export const fetchOpenFormDraft = async (
  query: { referenceNumber: string },
  opts?: CallUiApiOpts
): Promise<OpenFormDraft> => {
  return (await callUiApi(getOpenFormDraftPrivateMethod(query.referenceNumber), opts)).json();
};

export const fetchOpenFormDraftItemList = async (opts?: CallUiApiOpts): Promise<OpenFormDraftItem[]> => {
  return (await callUiApi(getOpenFormDraftItemListPrivateMethod(), opts)).json();
};

export const fetchOpenFormItemList = async (opts?: CallUiApiOpts): Promise<OpenFormListResponse> => {
  return (await callUiApi(getOpenFormItemListPrivateMethod(), opts)).json();
};

export const fetchOpenFormSummary = async (
  query: { choices: string[] },
  opts?: CallUiApiOpts
): Promise<OpenFormSummaryResponse> => {
  return (await callUiApi(getOpenFormSummaryPrivateMethod(query), opts)).json();
};

export const fetchOpenFormContactDetails = async (
  query: { contactIds: string },
  opts?: CallUiApiOpts
): Promise<OpenFormContactDetailsResponse> => {
  return (await callUiApi(getOpenFormContactDetailsPrivateMethod(query), opts)).json();
};

export const fetchOpenForm = async (query: { formId: string }, opts?: CallUiApiOpts): Promise<OpenFormResponse> => {
  return (await callUiApi(getOpenFormPrivateMethod(query), opts)).json();
};

export const postOpenForm = async (
  query: OpenFormCustomerNeedRequest,
  opts?: CallUiApiOpts
): Promise<OFReferenceNumber> => {
  return (await callUiApi(postOpenFormCustomerNeedPrivateMethod(), { ...opts, body: JSON.stringify(query) })).json();
};

export const postOpenFormDraft = async (
  query: OpenFormDraftUpsert,
  opts?: CallUiApiOpts
): Promise<OFReferenceNumber> => {
  return (await callUiApi(postOpenFormDraftPrivateMethod(), { ...opts, body: JSON.stringify(query) })).json();
};

export const deleteOpenFormDrafts = async (
  query: { referenceNumbers: string[] },
  opts?: CallUiApiOpts
): Promise<OFReferenceNumbers> => {
  return (await callUiApi(deleteOpenFormDraftsPrivateMethod(query), opts)).json();
};

export const fetchPublicPage = async (path: string): Promise<PageResponse> => {
  return (await callUiApi(getPageV3PublicMethod({ path }), { redirect: 'manual' })).json();
};

const getLoaderHeaders = (request: Request): Record<string, string> => {
  const forwardedFor = request.headers.get('X-Forwarded-For') ?? '';
  const realIp = request.headers.get('X-Real-IP') ?? forwardedFor.split(',')[0]?.trim() ?? '';
  return {
    ['Cookie']: request.headers.get('Cookie') ?? '',
    ...(forwardedFor ? { ['X-Forwarded-For']: forwardedFor } : {}),
    ...(realIp ? { ['X-Real-IP']: realIp } : {}),
  };
};

export const fetchPublicPageLoader = async (args: LoaderFunctionArgs): Promise<PageResponse> => {
  const { origin, pathname } = new URL(args.request.url);

  // Decode scandic letters; otherwise, getPageV3PublicMethod double encodes it
  const apiCall = getPageV3PublicMethod({ path: decodeURIComponent(pathname) });
  apiCall.path = origin + apiCall.path;
  const res = await callUiApi(apiCall, {
    headers: getLoaderHeaders(args.request),
    redirect: 'manual',
    useDefaultMdmId: false,
    noThrow: true,
  });

  if (res.status === 301) {
    throw new Response(res.body, {
      status: res.status,
      headers: new Headers({ location: createRedirectURL(args, res) }),
    });
  }
  if (res.ok) {
    return res.json();
  }
  throw new Response(res.body, { status: res.status, statusText: res.statusText });
};

export const IDEAT_ARTICLES_PER_PAGE = 18;
export const IDEAT_LANDING_ARTICLES_PER_PAGE = 19;

const IDEAT_LATEST_ARTICLES_COUNT = 7;

export type IdeatArticleLoaderData = {
  article: IdeatArticleResponse;
  latestArticles: IdeatArticlesResponse;
};

export const fetchIdeatArticleLoader = async ({
  params,
  request,
}: LoaderFunctionArgs): Promise<IdeatArticleLoaderData> => {
  const slug = params.ideatArticleSlug;
  if (!slug) {
    throw new Response('', { status: 404 });
  }
  const { origin } = new URL(request.url);
  const articleApiCall = getIdeatArticleV3PublicMethod(decodeURIComponent(slug));
  articleApiCall.path = origin + articleApiCall.path;
  const latestApiCall = getIdeatArticlesV3PublicMethod({ skip: 0, limit: IDEAT_LATEST_ARTICLES_COUNT });
  latestApiCall.path = origin + latestApiCall.path;

  const headers = getLoaderHeaders(request);
  const [articleRes, latestRes] = await Promise.all([
    callUiApi(articleApiCall, { headers, redirect: 'manual', useDefaultMdmId: false, noThrow: true }),
    callUiApi(latestApiCall, { headers, useDefaultMdmId: false, noThrow: true }),
  ]);

  if (!articleRes.ok) {
    throw new Response(articleRes.body, { status: articleRes.status, statusText: articleRes.statusText });
  }
  const article = await articleRes.json();
  const latestArticles = latestRes.ok ? await latestRes.json() : { total: 0, articles: [] };
  return { article, latestArticles };
};

export const fetchIdeatArticlesLoader = async ({
  params,
  request,
}: LoaderFunctionArgs): Promise<IdeatArticlesResponse> => {
  const { origin } = new URL(request.url);
  const isLandingPage = !params.ideatCategorySlug && !params.ideatTagSlug;
  const limit = isLandingPage ? IDEAT_LANDING_ARTICLES_PER_PAGE : IDEAT_ARTICLES_PER_PAGE;
  const pageNumber = Number(params.pageNumber ?? '1');
  const skip = (Number.isFinite(pageNumber) && pageNumber > 1 ? pageNumber - 1 : 0) * limit;
  const apiCall = getIdeatArticlesV3PublicMethod({
    category: params.ideatCategorySlug ? decodeURIComponent(params.ideatCategorySlug) : undefined,
    tag: params.ideatTagSlug ? decodeURIComponent(params.ideatTagSlug) : undefined,
    skip,
    limit,
  });
  apiCall.path = origin + apiCall.path;
  const res = await callUiApi(apiCall, {
    headers: getLoaderHeaders(request),
    useDefaultMdmId: false,
    noThrow: true,
  });
  if (res.ok) {
    return res.json();
  }
  throw new Response(res.body, { status: res.status, statusText: res.statusText });
};

export interface IdeatLandingLoaderData {
  articles: IdeatArticlesResponse;
  homepageConfig: IdeatHomepageConfigResponse;
}

export const fetchIdeatLandingLoader = async (args: LoaderFunctionArgs): Promise<IdeatLandingLoaderData> => {
  const { origin } = new URL(args.request.url);
  const [articles, homepageConfig] = await Promise.all([
    fetchIdeatArticlesLoader(args),
    (async () => {
      const apiCall = getIdeatHomepageConfigV3PublicMethod();
      apiCall.path = origin + apiCall.path;
      const res = await callUiApi(apiCall, {
        headers: getLoaderHeaders(args.request),
        useDefaultMdmId: false,
        noThrow: true,
      });
      if (res.ok) {
        return res.json() as Promise<IdeatHomepageConfigResponse>;
      }
      return undefined;
    })(),
  ]);
  return { articles, homepageConfig: homepageConfig! };
};

export interface IdeatCollectionMeta {
  title: string;
  slug: string;
  pageIntro?: Record<string, unknown>;
  description?: string;
  metaTitle?: string;
  metaDescription?: string;
}

const fetchIdeatCollectionMetaLoader = async (
  slug: string,
  getApiMethod: (slug: string) => ApiMethod,
  request: Request
): Promise<IdeatCollectionMeta> => {
  const { origin } = new URL(request.url);
  const apiCall = getApiMethod(decodeURIComponent(slug));
  apiCall.path = origin + apiCall.path;
  const res = await callUiApi(apiCall, {
    headers: getLoaderHeaders(request),
    useDefaultMdmId: false,
    noThrow: true,
  });
  if (res.ok) {
    return res.json();
  }
  throw new Response(res.body, { status: res.status, statusText: res.statusText });
};

export const fetchIdeatCategoryLoader = async ({ params, request }: LoaderFunctionArgs): Promise<IdeatCollectionMeta> =>
  fetchIdeatCollectionMetaLoader(params.ideatCategorySlug ?? '', getIdeatCategoryV3PublicMethod, request);

export const fetchIdeatTagLoader = async ({ params, request }: LoaderFunctionArgs): Promise<IdeatCollectionMeta> =>
  fetchIdeatCollectionMetaLoader(params.ideatTagSlug ?? '', getIdeatTagV3PublicMethod, request);

export interface IdeatCollectionLoaderData {
  articles: IdeatArticlesResponse;
  meta: IdeatCollectionMeta;
}

export const fetchIdeatCategoryWithMetaLoader = async (
  args: LoaderFunctionArgs
): Promise<IdeatCollectionLoaderData> => {
  const [articles, meta] = await Promise.all([fetchIdeatArticlesLoader(args), fetchIdeatCategoryLoader(args)]);
  return { articles, meta };
};

export const fetchIdeatTagWithMetaLoader = async (args: LoaderFunctionArgs): Promise<IdeatCollectionLoaderData> => {
  const [articles, meta] = await Promise.all([fetchIdeatArticlesLoader(args), fetchIdeatTagLoader(args)]);
  return { articles, meta };
};

export const fetchIdeatKeywordsLoader = async ({ request }: LoaderFunctionArgs): Promise<IdeatKeywordsResponse> => {
  const { origin } = new URL(request.url);
  const apiCall = getIdeatKeywordsV3PublicMethod();
  apiCall.path = origin + apiCall.path;
  const res = await callUiApi(apiCall, {
    headers: getLoaderHeaders(request),
    useDefaultMdmId: false,
    noThrow: true,
  });
  if (res.ok) {
    return res.json();
  }
  throw new Response(res.body, { status: res.status, statusText: res.statusText });
};

export const fetchIdeatHomepageConfigLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<IdeatHomepageConfigResponse> => {
  const { origin } = new URL(request.url);
  const apiCall = getIdeatHomepageConfigV3PublicMethod();
  apiCall.path = origin + apiCall.path;
  const res = await callUiApi(apiCall, {
    headers: getLoaderHeaders(request),
    useDefaultMdmId: false,
    noThrow: true,
  });
  if (res.ok) {
    return res.json();
  }
  throw new Response(res.body, { status: res.status, statusText: res.statusText });
};

export const registerIndividual = (registerIndividualRequest: RegisterIndividualRequest) => {
  return callUiApi(registerUserPrivateMethod(), {
    body: JSON.stringify({ ...registerIndividualRequest }),
    mdmId: registerIndividualRequest.accountMDMID,
  });
};

export const loginWithAccountCommunityUser = (accountMdmid: string) => {
  return callUiApi(loginWithAccountCommunityUserPrivateMethod(accountMdmid), {
    mdmId: accountMdmid,
  });
};

export const verifyEmailForEmployeeSelfRegistration = async (
  emailVerificationRequest: EmailVerificationRequest,
  resend: boolean
) => {
  return callUiApi(resend ? resendEmailVerificationPrivateMethod() : requestEmailVerificationPrivateMethod(), {
    body: JSON.stringify({ ...emailVerificationRequest }),
  });
};

export const verifyEmailOtpForEmployeeSelfRegistration = async (
  verifyEmailVerificationRequest: VerifyEmailVerificationRequest
) => {
  return callUiApi(verifyEmailVerificationPrivateMethod(), {
    body: JSON.stringify({ ...verifyEmailVerificationRequest }),
  });
};

export const verifyMobileForEmployeeSelfRegistration = async (mobileVerificationRequest: MobileVerificationRequest) => {
  return callUiApi(mobileVerificationRequestPrivateMethod(), {
    body: JSON.stringify({ ...mobileVerificationRequest }),
  });
};

export const verifyMobileOtpForEmployeeSelfRegistration = async (
  verifyMobileVerificationRequest: VerifyMobileVerificationRequest
): Promise<MobileOtpSelfRegistrationResponse> => {
  const res = await callUiApi(verifyMobileVerificationPrivateMethod(), {
    body: JSON.stringify({ ...verifyMobileVerificationRequest }),
    noThrow: true,
  });
  if (res.ok) {
    return { verified: true };
  } else if (res.status === 409) {
    const data = await res.json();
    return { verified: false, subscriptionSearchConflictResponse: data };
  }
  throw res;
};

export const verifyEmailAndProcessInvitation = async (request: VerifyEmailVerificationProcessInvitationRequest) => {
  return callUiApi(verifyEmailVerificationAndProcessInvitationPrivateMethod(), {
    body: JSON.stringify({ ...request }),
  });
};

export const upsertContactUser = (
  contact: Contact,
  forceUpsert: boolean,
  bothNamesChanged?: boolean,
  noThrow?: boolean,
  mdmId?: string
) => {
  if (contact.contactId) {
    const apiCall = updateContactPrivateMethod(contact.contactId, { forceUpsert, bothNamesChanged });
    return callUiApi(apiCall, { body: JSON.stringify(contact), noThrow: noThrow, mdmId });
  } else {
    return callUiApi(createContactPrivateMethod({ forceUpsert }), {
      body: JSON.stringify(contact),
      noThrow: noThrow,
      mdmId,
    });
  }
};

export const updateContactAccessRights = (
  contactMasterId: string,
  contactAccessRightsUpdateRequest: ContactAccessRightsUpdateRequest
) => {
  const apiCall = updateContactAccessRightsPrivateMethod(contactMasterId);
  return callUiApi(apiCall, { body: JSON.stringify(contactAccessRightsUpdateRequest) });
};

export const fetchOnlineModelHeaders = async (category: string): Promise<OnlineModelHeader[]> => {
  return (await callUiApi(getOnlineModelHeadersV3PublicMethod({ category }))).json();
};

export const fetchOnlineModelForCode = async (modelCode: string): Promise<OnlineModel> => {
  return (await callUiApi(getOnlineModelByCodeV3PublicMethod(modelCode))).json();
};

export const fetchOnlineModels = async (guids: string[]): Promise<OnlineModel[]> => {
  const responses = await Promise.all(
    guids.map(guid => callUiApi(getOnlineModelByCodeV3PublicMethod(guid), { noThrow: true }))
  );

  const result = await Promise.all(responses.map(r => (r.ok ? r.json() : undefined)));
  return result.filter(r => !!r);
};

export const fetchV3PrivateOnlineModels = async (
  codes: string[],
  voucherCode?: string,
  salesType?: SalesType,
  throwOnError = false,
  mdmId?: string,
  path?: string
): Promise<OnlineModel[]> => {
  // `path` lets loaders pass the request URL for SSR (window.location isn't available server-side),
  // falling back to the browser location for client-only call sites
  const requestPath = path ?? (isInBrowser() ? window.location.pathname : '');
  const isPunchoutUser = isPunchoutPath(requestPath);
  const isEmployee = isEoe(requestPath);
  const getPrivateOnlineModel = isPunchoutUser
    ? getPunchoutOnlineModelPrivateMethod
    : isEmployee
      ? getEmployeeOnlineModelPrivateMethod
      : getPrivateOnlineModelPrivateMethod;
  const responses = await Promise.all(
    codes.map(code =>
      callUiApi(
        getPrivateOnlineModel(
          code,
          voucherCode ? { salesType: salesType ?? SalesType.NEW_SALE, voucherCode } : undefined
        ),
        { ...(throwOnError ? {} : { noThrow: true }), ...(mdmId ? { mdmId } : {}) }
      )
    )
  );
  const result = await Promise.all(responses.map(r => (r.ok ? r.json() : undefined)));
  return result.filter((r): r is OnlineModel => !!r);
};

export const fetchV3PrivateOnlineModelHeaders = async (
  codes: string[],
  mdmId?: string
): Promise<OnlineModelHeader[]> => {
  const isPunchoutUser = isInBrowser() && isPunchoutPath(window.location.pathname);
  const isEmployee = isInBrowser() && isEoe(window.location.pathname);
  const getPrivateOnlineModelHeaders = isPunchoutUser
    ? getPunchoutOnlineModelHeadersPrivateMethod
    : isEmployee
      ? getEmployeeOnlineModelHeadersPrivateMethod
      : getPrivateOnlineModelHeadersPrivateMethod;
  const response = await callUiApi(
    getPrivateOnlineModelHeaders({ onlineModelCodes: codes }),
    mdmId ? { mdmId } : undefined
  );
  return response.json();
};

export const fetchVaihtoetuItemGroups = async (): Promise<VaihtoetuItemGroupList1[]> => {
  return (await callUiApi(getVaihtoetuItemGroupsPublicMethod())).json();
};

export const fetchVaihtoetuManufacturers = async (itemGroupId: number): Promise<VaihtoetuManufacturerList> => {
  return (await callUiApi(getVaihtoetuManufacturersPublicMethod({ itemGroupId }))).json();
};

export const fetchVaihtoetuModels = async (
  itemGroupId: number,
  manufacturerId: number
): Promise<VaihtoetuModelList> => {
  return (await callUiApi(getVaihtoetuModelsPublicMethod({ itemGroupId, manufacturerId }))).json();
};

export const fetchVaihtoetuGradingForm = async (modelId: number): Promise<VaihtoetuGradingForm> => {
  return (await callUiApi(getVaihtoetuGradingFormPublicMethod(modelId))).json();
};

export const submitVaihtoetuPriceQuote = async (
  data: VaihtoetuPriceQuoteRequest
): Promise<VaihtoetuPriceQuoteResponse> => {
  return (
    await callUiApi(submitVaihtoetuPriceQuotePublicMethod(), {
      body: JSON.stringify(data),
    })
  ).json();
};

export const fetchNavigation = async (query: { locale: string }): Promise<NavigationResponse> => {
  return (await callUiApi(getNavigationV3PublicMethod(query))).json();
};

export const fetchNavigationLoader = async ({ request }: LoaderFunctionArgs): Promise<NavigationResponse> => {
  const url = new URL(request.url);
  const localeFromPath = resolveLocaleFromPath(url.pathname, getLocale());
  const locale = localeFromPath?.content ?? getLocale();
  const opts = {
    headers: getLoaderHeaders(request),
    useDefaultMdmId: false,
    noThrow: true,
  } as const;

  const fetchNavigationForLocale = async (navLocale: Locale): Promise<NavigationResponse | undefined> => {
    const apiCall = getNavigationV3PublicMethod({ locale: navLocale });
    apiCall.path = `${url.origin}${apiCall.path}`;
    const res = await callUiApi(apiCall, opts);
    if (res.ok) {
      const data: NavigationResponse = await res.json();
      if (data.menu?.length) {
        return data;
      }
    }
    return undefined;
  };

  // Try selected language first, then fall back to Finnish CMS navigation
  const result =
    (await fetchNavigationForLocale(locale)) ??
    (locale !== Locale.FI ? await fetchNavigationForLocale(Locale.FI) : undefined);
  return (
    result ?? {
      menu: [],
      footer: {
        columns: [],
        disclaimerLinks: {
          links: [],
          cookieSettingsText: '',
        },
        socialLinks: {},
        copyrightYear: new Date().getFullYear().toString(),
      },
    }
  );
};

export const fetchDomains = async (query: string) => {
  return (await callUiApi(domainGetPublicMethod({ query }))).json();
};

export const fetchDnsRecords = async (subId: string, query: DnsRecordsRequestQuery): Promise<DnsRecordsResponse> => {
  return (await callUiApi(getDnsRecordsPrivateMethod(subId, query))).json();
};

export const fetchDnsRecordsHistory = async (
  subId: string,
  query: DnsRecordsRequestQuery
): Promise<DnsRecordsHistoryResponse> => {
  return (await callUiApi(getDnsRecordsHistoryPrivateMethod(subId, query))).json();
};

export const fetchDnsRecordHistory = async (subId: string, historyId: number): Promise<DnsRecordsHistoryResponse> => {
  return (await callUiApi(getDnsRecordHistoryPrivateMethod(historyId, subId))).json();
};

export const deleteDnsRecord = async (subscriptionId: string, recordId: number) => {
  return callUiApi(deleteDnsRecordPrivateMethod(recordId, subscriptionId));
};

export const updateDnsRecord = async (subscriptionId: string, recordId: number, payload: DnsRecordRequest) => {
  return callUiApi(updateDnsRecordPrivateMethod(recordId, subscriptionId), { body: JSON.stringify(payload) });
};

export const createDnsRecord = async (subscriptionId: string, payload: DnsRecordRequest) => {
  return callUiApi(createDnsRecordPrivateMethod(subscriptionId), { body: JSON.stringify(payload) });
};

export const postPublicLead = (body: PostAnonymousLeadRequest) => {
  return callUiApi(createAnonymousLeadPublicMethod(), { body: JSON.stringify(body), useDefaultMdmId: false });
};

export const postPrivateLead = (body: PostLeadRequest) => {
  return callUiApi(createLeadPrivateMethod(), { body: JSON.stringify(body) });
};

export const fetchAddOnRules = async (subscriptionType?: string): Promise<AddOnRulesResponse> => {
  const apiCall = getAddOnRulesPublicMethod({ subscriptionType });
  const res = await callUiApi(apiCall, { useDefaultMdmId: false, noThrow: true });

  if (res.ok) {
    return res.json();
  }

  // If add-on rules cannot be fetched, the add-on cannot be sold but the main article is still potentially available for purchase. By returning an empty response, buying the main article is still possible.
  return { ...emptyAddOnRulesResponse };
};

export const fetchPublicAddOnsVisibilities = async (
  cpCode: string,
  operationType: AddOnVisibilityOperationType
): Promise<AddOnVisibilityResponse> => {
  const apiCall = getAddOnVisibilityPublicMethod(cpCode, { operationType });
  const res = await callUiApi(apiCall, { useDefaultMdmId: false, noThrow: true });

  if (res.ok) {
    return res.json();
  }

  // If add-on visibilities cannot be fetched, we cannot decide which add-ons are available for selection. The main article is still potentially available for purchase. By returning an empty response, buying the main article is still possible.
  return {
    total: 0,
    addOnVisibilities: [],
  };
};

export const fetchNewSalesAddOnsVisibilities = async (cpCode: string): Promise<AddOnVisibilityResponse> =>
  fetchPublicAddOnsVisibilities(cpCode, AddOnVisibilityOperationType.NEW_SALES);

export const fetchAddOnsVisibilities = async (
  cpCode: string,
  operationType: AddOnVisibilityOperationType,
  mdmId?: string
): Promise<AddOnVisibilityResponse> => {
  return (await callUiApi(getAddOnVisibilityPrivateMethod(cpCode, { operationType: operationType }), { mdmId })).json();
};

export const postFile = async (file: File): Promise<PostFileResponse> => {
  const body = new FormData();
  body.append('fileData', file);
  return (await callUiApi(postFilePrivateMethod(), { body, jsonContent: false })).json();
};

export const fetchReports = async (): Promise<ReportItemResponse[]> => {
  return (await callUiApi(getReportsPrivateMethod(), { useDefaultMdmId: false })).json();
};

export const generateReport = (reportType: ReportType, mdmIds?: string[], requestedDate?: string) => {
  return callUiApi(generateReportPrivateMethod(reportType), {
    noThrow: true,
    useDefaultMdmId: false,
    body: JSON.stringify({ accountMasterIds: mdmIds, requestedDate }),
  });
};

export const downloadReport = (reportId: string, onlineReportId: string) => {
  return callUiApi(getGeneratedReportPrivateMethod(reportId, { onlineReportId }), { noThrow: true });
};

export const downloadWarrantyReceiptPdf = (deliveryOrderId: string) => {
  return callUiApi(getWarrantyReceiptPdfPrivateMethod(deliveryOrderId), { noThrow: true });
};

export const downloadOrderConfirmationPdf = (customerOrderDisplayId: string) => {
  return callUiApi(getOrderConfirmationPdfPrivateMethod(customerOrderDisplayId), { noThrow: true });
};

export const fetchBillingAccount = async (
  billingAccountDisplayId: string,
  mdmId: string
): Promise<BillingAccountsResponse> => {
  const apiCall = getBillingAccountsPrivateMethod({ offset: 0, billingAccountDisplayId });
  return (await callUiApi(apiCall, { mdmId })).json();
};

export const fetchBillingAccounts = async (
  query: BillingAccountsQuery,
  opts?: CallUiApiOpts
): Promise<BillingAccountsResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true && !opts?.isPunchout && !opts?.isEmployee
      ? getSearchBillingAccountsV3PrivateMethod(query)
      : getBillingAccountsPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      ...opts,
      useDefaultMdmId: false,
    })
  ).json();
};

export const fetchBillingAccountsCoco = async (
  query?: LimitableQuery & { fields?: string },
  opts?: CallUiApiOpts
): Promise<BillingAccountCoco[]> => {
  const apiCall = getBillingAccountsCocoPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      ...opts,
      useDefaultMdmId: false,
    })
  ).json();
};

export const fetchBillingAccountCoco = async (
  id: string,
  mdmId?: string,
  query?: { fields?: string }
): Promise<BillingAccountCoco> => {
  const apiCall = getBillingAccountByIdCocoPrivateMethod(id, query);
  return (await callUiApi(apiCall, { mdmId })).json();
};

export const fetchEmployeeProductSelections = async (mdmId: string): Promise<EmployeeProductSelectionResponse[]> =>
  (await callUiApi(getEmployeeProductSelectionsPrivateMethod({ mdmId }), { mdmId })).json();

// Lists of several companies are fetched with comma separated mdmIds and without the company header, as the header
// would restrict the request to a single company
export const fetchEmployeeProductLists = async (mdmIds: string[]): Promise<EmployeeProductListResponse[]> =>
  (
    await callUiApi(
      getEmployeeProductListsPrivateMethod({ mdmId: mdmIds.join(',') }),
      mdmIds.length === 1 ? { mdmId: mdmIds[0] } : { useDefaultMdmId: false }
    )
  ).json();

export const fetchEmployeeProductList = async (uuid: string, mdmId?: string): Promise<EmployeeProductListResponse> =>
  (await callUiApi(getEmployeeProductListPrivateMethod(uuid), { mdmId })).json();

export const fetchEmployeeProductSelection = async (
  uuid: string,
  mdmId?: string
): Promise<EmployeeProductSelectionResponse> =>
  (await callUiApi(getEmployeeProductSelectionPrivateMethod(uuid), { mdmId })).json();

export const replaceCatalogs = async (
  payload: VirtualCatalogReplaceRequest
): Promise<VirtualCatalogReplaceResponse> => {
  return (await callUiApi(replaceVirtualCatalogsPrivateMethod(), { body: JSON.stringify(payload) })).json();
};

// A given body status must match the action, otherwise the API returns HTTP 400
export const createEmployeeProductList = (payload: EmployeeProductListRequest, action: DeviceListActionCoCo) =>
  callUiApi(createEmployeeProductListPrivateMethod(), {
    body: JSON.stringify(payload),
    mdmId: payload.accountMdmId,
    headers: { [PRODUCT_LIST_ACTION_HEADER]: action },
  });

// Creates a replacement version of the list with a new uuid and deprecates the previous version
export const patchEmployeeProductList = (
  uuid: string,
  payload: PatchEmployeeProductListRequest,
  action: DeviceListActionCoCo,
  mdmId?: string
): Promise<EmployeeProductListResponse> =>
  callUiApi(patchEmployeeProductListPrivateMethod(uuid), {
    body: JSON.stringify(payload),
    mdmId,
    headers: { [PRODUCT_LIST_ACTION_HEADER]: action },
  }).then(response => response.json());

export const createEmployeeProductSelection = (payload: EmployeeProductSelectionRequest) =>
  callUiApi(createEmployeeProductSelectionPrivateMethod(), {
    body: JSON.stringify(payload),
    mdmId: payload.accountMdmId,
  });

export const patchEmployeeProductSelection = (
  uuid: string,
  payload: PatchEmployeeProductSelectionRequest,
  mdmId: string
) => callUiApi(patchEmployeeProductSelectionPrivateMethod(uuid), { body: JSON.stringify(payload), mdmId });

export const removeEmployeeProductList = (uuid: string, mdmId?: string) =>
  callUiApi(deleteEmployeeProductListPrivateMethod(uuid), { mdmId });

export const deleteEmployeeProductSelection = (uuid: string, mdmId: string) =>
  callUiApi(deleteEmployeeProductSelectionPrivateMethod(uuid), { mdmId });

export const createBillingAccount = async (billingAccount: BillingAccount, mdmId?: string) => {
  return (await callUiApi(createBillingAccountPrivateMethod(), { body: JSON.stringify(billingAccount), mdmId })).json();
};

export const createBillingAccountCoco = async (
  billingAccount: BillingAccountCreateRequestCoco,
  mdmId?: string
): Promise<BillingAccountCoco> => {
  const apiCall = createBillingAccountCocoPrivateMethod();
  return (await callUiApi(apiCall, { body: JSON.stringify(billingAccount), mdmId })).json();
};

export const updateBillingAccount = async (billingAccountId: string, billingAccount: BillingAccount) => {
  return (
    await callUiApi(updateBillingAccountPrivateMethod(billingAccountId), { body: JSON.stringify(billingAccount) })
  ).json();
};

export const createPersonBillingAccount = async (
  payload: UpsertPersonBillingAccountRequest
): Promise<PutBillingAccountResponse> => {
  return (await callUiApi(createEmployeePersonBillingAccountPrivateMethod(), { body: JSON.stringify(payload) })).json();
};

export const updatePersonBillingAccount = async (
  payload: UpsertPersonBillingAccountRequest
): Promise<PutBillingAccountResponse> => {
  return (await callUiApi(updateEmployeePersonBillingAccountPrivateMethod(), { body: JSON.stringify(payload) })).json();
};

export const fetchBillChannels = async (mdmId?: string, opts?: CallUiApiOpts) => {
  return (await callUiApi(getBillChannelsPublicMethod({ mdmId }), opts)).json();
};

export interface GlobalSearchQuery {
  query: string;
  searchAllAccounts?: boolean;
  searchType?: string[];
}

export const fetchGlobalSearch = async ({ query, searchAllAccounts, searchType }: GlobalSearchQuery) => {
  const searchResultTypes =
    searchType && searchType.length > 0
      ? searchType
      : Object.values(SearchResultType).filter(
          type => type !== SearchResultType.DOMAIN || getFeatureFlags().dnsManagement === true
        );
  const apiCall = isSearchApiV3Enabled()
    ? getSearchGlobalV3PrivateMethod({ query, searchResultTypes })
    : globalSearchPrivateMethod({ query, searchType });
  return (await callUiApi(apiCall, { useDefaultMdmId: !searchAllAccounts })).json();
};

export const fetchSubscriptionAggregates = async (
  subscriptionCategory: SubscriptionCategory,
  request: Request,
  mdmId?: string,
  excludeEpp?: boolean,
  billingAccountRecordType?: string,
  excludeCardPayment?: boolean
): Promise<SubscriptionAggregationsResponse> => {
  const params = new URLSearchParams(new URL(request.url).search);
  const search = params.get('search') || undefined;
  const getAggregations = isSearchApiV3Enabled()
    ? getSearchSubscriptionAggregationsV3PrivateMethod
    : getSubscriptionAggregationsPrivateMethod;
  const apiCall = getAggregations({
    subscriptionCategory,
    search,
    excludeEpp,
    billingAccountRecordType,
    excludeCardPayment,
  });
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export type SubscriptionsQuery = SortableLimitableQuery &
  SubscriptionsDeviceMultiFilter & {
    details?: boolean;
    search?: string;
    subscriptionType?: string[];
    subscriptionDisplayId?: string;
    useSearchService?: boolean;
    subscriptionContactId?: string;
    expiringOrExpired?: boolean;
    eppOnly?: boolean;
    excludeEpp?: boolean;
    billingAccountRecordType?: string;
  };

export type CampaignsQuery = {
  salesType: string;
  voucher: string;
  onlineModel: string;
};

const fetchSubscriptionByDisplayId = async (
  category: SubscriptionCategory,
  subscriptionDisplayId: string,
  mdmId: string
): Promise<Subscription> => {
  const subscriptionTypes = getSubscriptionTypes(category);
  const response = await callUiApi(
    getSubscriptionsPrivateMethod({
      offset: 0,
      details: true,
      subscriptionType: subscriptionTypes,
      subscriptionDisplayId,
    }),
    {
      mdmId,
    }
  );
  const subscriptionsResponse: SubscriptionsResponse = await response.json();
  const subscription = subscriptionsResponse?.subscriptions?.[0];
  if (!subscription) {
    throw new Response('Subscription not found', { status: 404 });
  }
  return subscription;
};

const fetchSubscriptionById = async (subscriptionId: string, mdmId: string): Promise<Subscription> => {
  const response = await callUiApi(getSubscriptionPrivateMethod(subscriptionId), {
    mdmId,
  });
  return await response.json();
};

export const fetchSubscription = async (
  category: SubscriptionCategory,
  subscriptionId: string,
  mdmId: string
): Promise<Subscription> => {
  if (subscriptionId.startsWith('SUB')) {
    return fetchSubscriptionByDisplayId(category, subscriptionId, mdmId);
  }
  return fetchSubscriptionById(subscriptionId, mdmId);
};

export const fetchSubscriptions = async (query: SubscriptionsQuery, mdmId?: string): Promise<SubscriptionsResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true
      ? getSearchSubscriptionsV3PrivateMethod({ ...query, subscriptionType: query.subscriptionType ?? [] })
      : getSubscriptionsPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const fetchEmployeeSubscriptions = async (query: SubscriptionsQuery): Promise<SubscriptionsResponse> => {
  return (await callUiApiForEmployee(getSubscriptionsPrivateMethod(query))).json();
};

export const fetchCampaigns = async (query: CampaignsQuery): Promise<CampaignsResponse> => {
  return (await callUiApi(getCampaignsPublicMethod(query))).json();
};

export type ContactFetchQuery = SortableLimitableQuery & {
  search?: string;
  useSearchService?: boolean;
};

export const fetchContacts = async (query: ContactFetchQuery, opts?: CallUiApiOpts): Promise<ContactsResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true
      ? getSearchContactsV3PrivateMethod(query)
      : getContactsPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      ...opts,
      useDefaultMdmId: false,
    })
  ).json();
};

export const fetchContactsBillingAccounts = async (contactId: string) => {
  return (await callUiApi(getContactBillingAccountsPrivateMethod(contactId))).json();
};

export const parameterizedSearchContacts = async (
  query: { searchTerm: string },
  opts?: CallUiApiOpts
): Promise<ParameterizedSearchContactResults> => {
  return (await callUiApi(parameterizedSearchContactsPrivateMethod(query), opts)).json();
};

export const fetchExternalAuthMethods = async (): Promise<AuthenticationMethod[] | 'failed'> => {
  try {
    return (await (await callUiApi(getExternalAuthenticationMethodsPublicMethod())).json()).authenticationMethods;
  } catch {
    // This is a special case, we want to have graceful degraded functionality. The extAuthMethods come from 3rd party, if that system has issues we don't want it to impact online-ui more than it has to.
    return 'failed';
  }
};

export const fetchContact = async ({
  contactMasterId,
  mdmId,
}: {
  contactMasterId: string;
  mdmId: string;
}): Promise<Contact> => {
  const response = await callUiApi(getContactsPrivateMethod({ contactMasterId }), { mdmId });
  const contactsResponse: ContactsResponse = await response.json();
  const contact = contactsResponse?.contacts?.[0];
  if (!contact) {
    throw new Response('Contact not found', { status: 404 });
  }
  return contact;
};

export const requestMfaOtp = async () => {
  return callUiApi(raiseAuthenticationLevelPrivateMethod());
};

export const sendMfaOtp = async (otp: string): Promise<boolean> => {
  const res = await callUiApi(raiseAuthenticationLevelValidateOtpPrivateMethod(otp), { noThrow: true });

  if (res.ok) {
    return true;
  } else if (res.status === 400) {
    return false;
  }

  throw new Error(res.statusText);
};

export const validateNumbers = async (
  payload: ValidateAvailabilityOfNumbersRequest
): Promise<ValidateAvailabilityOfNumbersResponse> => {
  return (await callUiApi(validateAvailabilityOfNumbersPrivateMethod(), { body: JSON.stringify(payload) })).json();
};

export type GenerateNumbersQuery = {
  count: number;
};

export const generateNumbers = async (query: GenerateNumbersQuery): Promise<NewNumbersResponse> => {
  return (await callUiApi(generateNumbersPrivateMethod(query))).json();
};

export const createSupportCaseAnonymous = async (
  supportCase: SupportCase,
  contactDetails: ContactSupportInfo,
  reCaptchaResponse?: string
) => {
  const body = JSON.stringify({ supportCase, contactDetails, reCaptchaResponse });
  return (await callUiApi(createAnonymousSupportCasePublicMethod(), { body: body })).json();
};

export const createSupportCaseAuthenticated = async (
  supportCase: SupportCase,
  mdmId: string
): Promise<PutSupportCaseResponse> =>
  (
    await callUiApi(createSupportCasePrivateMethod(), {
      body: JSON.stringify(supportCase),
      mdmId,
      useDefaultMdmId: false,
    })
  ).json();

export const fetchSupportCase = async (supportCaseDisplayId: string, mdmId: string) => {
  const apiCall = getSupportCasePrivateMethod(supportCaseDisplayId);
  return (await callUiApi(apiCall, { mdmId })).json();
};

export const fetchSupportCases = async (query: SupportCasesQuery, mdmId?: string): Promise<SupportCasesResponse> => {
  const apiCall = isSearchApiV3Enabled()
    ? getSearchSupportCasesV3PrivateMethod(query)
    : getSupportCasesPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const fetchSupportCaseHistory = async (
  supportCaseDisplayId: string,
  mdmId: string
): Promise<SupportCaseDetails> => {
  const apiCall = getSupportCaseHistoryPrivateMethod(supportCaseDisplayId);
  return (await callUiApi(apiCall, { mdmId })).json();
};

export const fetchOpenSupportCases = async (
  query?: SupportCasesQuery,
  mdmId?: string
): Promise<SupportCasesResponse> => {
  const apiCall = isSearchApiV3Enabled()
    ? getSearchOpenSupportCasesV3PrivateMethod(query)
    : getOpenSupportCasesPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const fetchCustomerOrders = async (
  query: CustomerOrdersQuery,
  isEmployee: boolean,
  mdmId?: string
): Promise<CustomerOrdersResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true && !isEmployee
      ? getSearchCustomerOrdersV3PrivateMethod(query)
      : getCustomerOrdersPrivateMethod(query);
  if (isEmployee) {
    return (await callUiApiForEmployee(apiCall)).json();
  } else {
    return (await callUiApi(apiCall, { useDefaultMdmId: false, mdmId })).json();
  }
};

export type CocoOrdersQuery = SortableLimitableQuery & {
  company?: string;
  orderType?: string;
  state?: string;
  dateFrom?: string;
  dateTo?: string;
  productType?: string;
  changeType?: string;
  search?: string;
};

export interface CocoOrdersResponse {
  orders: CocoProductOrderSummary[];
  total: number;
}

export const fetchCocoOrders = async (query: CocoOrdersQuery, mdmId?: string): Promise<CocoOrdersResponse> => {
  const response = await callUiApi(getOrdersPrivateMethod(query), { useDefaultMdmId: false, mdmId });
  return {
    orders: await response.json(),
    total: Number(response.headers.get('X-Total-Count') ?? 0),
  };
};

export const fetchCocoOrder = async (orderId: string, mdmId?: string): Promise<CocoProductOrderDetail> => {
  return (await callUiApi(getOrderByIdPrivateMethod(orderId), { useDefaultMdmId: false, mdmId })).json();
};

export const fetchChangeRequestDetails = async (changeRequestId: string): Promise<ChangeRequestDetails> => {
  return (await callUiApi(getChangeRequestDetailsPrivateMethod(changeRequestId))).json();
};

export const fetchUserCustomerOrders = async (query: CustomerOrdersQuery): Promise<CustomerOrdersResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true
      ? getSearchEmployeeCustomerOrdersV3PrivateMethod(query)
      : getUserCustomerOrdersPrivateMethod(query);
  return (await callUiApiForEmployee(apiCall)).json();
};

export const fetchCustomerOrderAdditionalInfo = async (
  customerOrderId: string,
  isEmployee: boolean,
  mdmId?: string
): Promise<CustomerOrderAdditionalInfo> => {
  if (isEmployee) {
    return (await callUiApiForEmployee(getCustomerOrderAdditionalInfoPrivateMethod(customerOrderId))).json();
  } else {
    return (await callUiApi(getCustomerOrderAdditionalInfoPrivateMethod(customerOrderId), { mdmId })).json();
  }
};

export const fetchBillingAccountScheduledChange = async (
  billingAccountId: string
): Promise<BillingAccountScheduledChangeResponse> => {
  return (await callUiApi(getBillingAccountScheduledChangePrivateMethod(billingAccountId))).json();
};

export const fetchSubscriptionScheduledChanges = async (
  subscriptionId: string
): Promise<GetSubscriptionScheduledChanges> => {
  return (await callUiApi(getSubscriptionScheduledChangePrivateMethod(subscriptionId))).json();
};

export const cancelSubscriptionScheduledChange = async (
  subscriptionId: string,
  changeRequestId: string
): Promise<SubscriptionScheduledChangeUpdateResponse> => {
  const body = {
    subscriptionScheduledChangeRequests: [
      {
        subscriptionId,
        changeRequestId,
        changeRequestStatus: ChangeRequestStatus.CANCELLED,
      },
    ],
  };
  return (
    await callUiApi(putSubscriptionScheduledChangePrivateMethod(subscriptionId), { body: JSON.stringify(body) })
  ).json();
};

export const scheduleBillingAccountChange = async (
  billingAccountId: string,
  scheduledChangeTimestamp: number,
  billingAccount: BillingAccount
): Promise<BillingAccountScheduledChangeState> => {
  const apiCall = postScheduledBillingAccountChangePrivateMethod(billingAccountId);
  return (await callUiApi(apiCall, { body: JSON.stringify({ billingAccount, scheduledChangeTimestamp }) })).json();
};

export const reScheduleBillingAccountChange = async (
  billingAccountId: string,
  scheduledChangState: BillingAccountScheduledChangeState
): Promise<BillingAccountScheduledChangeState> => {
  const body: BillingAccountScheduledChangeState = {
    billingAccountId,
    changeRequestId: scheduledChangState.changeRequestId,
    scheduledChangeTimestamp: scheduledChangState.scheduledChangeTimestamp,
  };
  return (
    await callUiApi(putScheduledBillingAccountChangePrivateMethod(billingAccountId), { body: JSON.stringify(body) })
  ).json();
};

export const cancelChangeRequest = async (
  billingAccountId: string,
  changeRequestId: string
): Promise<BillingAccountScheduledChangeState> => {
  const body: BillingAccountScheduledChangeState = {
    billingAccountId,
    changeRequestId,
    changeRequestStatus: ChangeRequestStatus.CANCELLED,
  };
  return (
    await callUiApi(putScheduledBillingAccountChangePrivateMethod(billingAccountId), { body: JSON.stringify(body) })
  ).json();
};

export const fetchSubscriptionActions = async (
  query: SubscriptionActionsQuery,
  isEmployee: boolean,
  mdmId?: string
): Promise<SubscriptionActionsResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true && !isEmployee
      ? getSearchSubscriptionActionsV3PrivateMethod(query)
      : getSubscriptionActionsPrivateMethod(query);
  if (isEmployee) {
    return (await callUiApiForEmployee(apiCall)).json();
  } else {
    return (await callUiApi(apiCall, { useDefaultMdmId: false, mdmId })).json();
  }
};

export const fetchVirtualCatalog = async (catalogCode: string, mdmId: string) => {
  const apiCall = getVirtualCatalogPrivateMethod(catalogCode);
  return (await callUiApi(apiCall, { mdmId })).json();
};

export const fetchVirtualCatalogs = async (
  query: VirtualCatalogsQuery,
  mdmId?: string
): Promise<VirtualCatalogResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query.useSearchService === true
      ? getSearchVirtualCatalogsV3PrivateMethod(query)
      : getVirtualCatalogsPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const createVirtualCatalog = async (catalog: Catalog, mdmId: string): Promise<PutVirtualCatalogResponse> => {
  return (await callUiApi(createVirtualCatalogPrivateMethod(), { body: JSON.stringify(catalog), mdmId })).json();
};

export const deprecateVirtualCatalog = async (virtualCatalogCode: string, mdmId?: string) => {
  return callUiApi(deprecateVirtualCatalogPrivateMethod(virtualCatalogCode), {
    mdmId,
    useDefaultMdmId: false,
  });
};

export const updateDraftCatalog = async (
  virtualCatalogCode: string,
  catalog: Catalog,
  mdmId?: string
): Promise<PutVirtualCatalogResponse> => {
  return await (
    await callUiApi(updateDraftCatalogPrivateMethod(virtualCatalogCode, catalog.catalogCode!), {
      body: JSON.stringify(catalog),
      mdmId,
    })
  ).json();
};

export const createDraftCatalog = async (
  virtualCatalogCode: string,
  catalog: Catalog,
  mdmId?: string
): Promise<PutVirtualCatalogResponse> => {
  return await (
    await callUiApi(createDraftCatalogPrivateMethod(virtualCatalogCode), {
      body: JSON.stringify(catalog),
      mdmId,
    })
  ).json();
};

export const publishDraftCatalog = async (virtualCatalogCode: string, payload: Catalog, mdmId?: string) => {
  return callUiApi(publishDraftCatalogPrivateMethod(virtualCatalogCode), { body: JSON.stringify(payload), mdmId });
};

export const deleteVirtualCatalogDraft = async (virtualCatalogCode: string, catalogCode: string, mdmId?: string) => {
  return callUiApi(deleteDraftCatalogPrivateMethod(virtualCatalogCode, catalogCode), { mdmId });
};

export const fetchCompanyInfo = async (
  mdmId?: string,
  isEmployee = false,
  isPunchout = false
): Promise<CompanyInfoResponse> => {
  if (isEmployee) {
    return (await callUiApiForEmployee(getMyselfAccountPrivateMethod())).json();
  } else if (isPunchout) {
    return (await callUiApiForPunchout(getMyselfAccountPrivateMethod())).json();
  } else {
    return (await callUiApi(getMyselfAccountPrivateMethod(), { mdmId })).json();
  }
};

// The mdmIds of all the companies of the logged in user, read from the auth validation, as loaders can't access the
// auth context and the primary mdmId might not be in the local storage yet on the first page load
export const getRelatedCompanyHierarchyDetails = async (): Promise<string[]> => {
  const response = await callUiApi(validatePublicMethod(), { useDefaultMdmId: false, noThrow: true });
  const { result }: { result?: AuthenticationResult } = response.ok ? await response.json().catch(() => ({})) : {};
  const primaryMdmId =
    result?.contact?.accountContactRelationships?.find(acr => acr.isPrimaryAccount)?.accountMasterId ??
    result?.account?.accountMasterId;
  return [
    ...new Set([primaryMdmId, ...(result?.secondaryAccounts ?? []).map(account => account.accountMasterId)]),
  ].filter((mdmId): mdmId is string => Boolean(mdmId));
};

export const fetchSecondaryAccounts = async (mdmId: string): Promise<SecondaryAccount[]> => {
  return (await callUiApi(getMyselfSecondaryAccountsPrivateMethod(), { mdmId })).json();
};

export const fetchAllSecondaryCompanyInfos = async (primaryMdmId: string): Promise<SecondaryAccountCompanyInfo[]> => {
  return (await callUiApi(getMyselfSecondaryAccountsCompanyInfosPrivateMethod(), { mdmId: primaryMdmId })).json();
};

export const fetchCompanyInfoAndEnabledOnlineModels = async (
  mdmId?: string
): Promise<{ companyInfo: CompanyInfoResponse; onlineModels: OnlineModel[] }> => {
  const accountRes = await callUiApi(getMyselfAccountPrivateMethod(), {
    mdmId,
  });
  const companyInfo = await accountRes.json();

  const visibleOffers: Array<{ offerCodes: string[]; onlineModelCode: string }> =
    companyInfo?.uiOptions?.visibleOffers ?? [];
  const onlineModels = await Promise.all(
    visibleOffers
      .map(offer => offer.onlineModelCode)
      .filter(Boolean)
      .map(async code => (await callUiApi(getOnlineModelByCodeV3PublicMethod(code))).json())
  );

  if (
    companyInfo?.pbxSolutions?.filter(
      (solution: Subscription) => solution.subscriptionType === SubscriptionType.MOBILE_PBX
    ).length > 0
  ) {
    const [ringModel] = await fetchV3PrivateOnlineModels([ModelType.Ring], undefined, undefined, true, mdmId);
    onlineModels.push(ringModel);
  }

  return {
    companyInfo,
    onlineModels,
  };
};

export const updateCompanyInfo = async (updateRequest: UpdateAccountRequest, mdmId: string) => {
  return await callUiApi(updateMyselfAccountPrivateMethod(), { body: JSON.stringify(updateRequest), mdmId });
};

export const createInterworksRedirectUrl = async (iwAccountId: number, accountMasterId: string) => {
  return (
    await callUiApi(licenseManagementUrlPrivateMethod({ accountId: iwAccountId }), { mdmId: accountMasterId })
  ).json();
};

export const createInterworksAccount = async (
  request: CreateInterworksAccountRequest,
  accountMasterId: string
): Promise<number> => {
  return (
    await callUiApi(postCreateInterworksAccountPrivateMethod(), {
      body: JSON.stringify(request),
      mdmId: accountMasterId,
    })
  ).json();
};

export const fetchLicenseManagementAccounts = async (accountMasterId: string): Promise<LicenseManagementAccount[]> => {
  return (
    await callUiApi(getLicenseManagementAccountsPrivateMethod(), {
      mdmId: accountMasterId,
    })
  ).json();
};

export const fetchInvoice = async (invoiceDisplayId: string, mdmId: string): Promise<InvoicesResponse> => {
  return (
    await callUiApi(getInvoicesPrivateMethod({ offset: 0, invoiceDisplayId }), {
      mdmId,
    })
  ).json();
};

export const fetchInvoices = async (query?: InvoicesQuery, mdmId?: string): Promise<InvoicesResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query?.useSearchService === true
      ? getSearchInvoicesV3PrivateMethod(query)
      : getInvoicesPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const fetchInvoiceDocuments = async (
  query?: InvoiceDocumentsQuery,
  mdmId?: string
): Promise<InvoiceDocumentsResponse> => {
  const apiCall =
    isSearchApiV3Enabled() && query?.useSearchService === true
      ? getSearchInvoiceDocumentsV3PrivateMethod(query)
      : getDocumentsPrivateMethod(query);
  return (
    await callUiApi(apiCall, {
      useDefaultMdmId: false,
      mdmId,
    })
  ).json();
};

export const createShoppingBasket = async (shoppingBasket: ShoppingCart): Promise<ShoppingCartResponse> => {
  return (await callUiApi(createShoppingCartPrivateMethod(), { body: JSON.stringify(shoppingBasket) })).json();
};

export const updateShoppingBasket = async (
  shoppingBasketId: string,
  shoppingBasket: ShoppingCart
): Promise<ShoppingCartResponse> => {
  return (
    await callUiApi(updateShoppingCartPrivateMethod(shoppingBasketId), { body: JSON.stringify(shoppingBasket) })
  ).json();
};

export const finalizeShoppingBasket = async (
  shoppingBasketId: string,
  orderId: string
): Promise<ShoppingCartResponse> => {
  return (
    await callUiApi(finalizeShoppingCartPrivateMethod(shoppingBasketId), {
      body: JSON.stringify({ orderId }),
    })
  ).json();
};

export const changeSubscriptionBillingAccount = async (
  subscriptionId: string,
  billingAccountId: string,
  mdmId: string
) => {
  const payload = { billingAccountId };
  return (
    await callUiApi(changeSubscriptionBillingAccountPrivateMethod(subscriptionId), {
      body: JSON.stringify(payload),
      mdmId,
    })
  ).json();
};

export const fetchHolidays = async (opts?: CallUiApiOpts): Promise<HolidaysResponse> => {
  return (await callUiApi(getHolidaysPublicMethod(), opts)).json();
};

export const fetchSubscriptionMonthlyUsageDetails = async (
  month: string,
  subscriptionId: string
): Promise<MonthlyUsageDetailsResponse> => {
  return (await callUiApi(getMonthlyUsageDetailsPrivateMethod(month, subscriptionId))).json();
};

export const fetchElisaIdV2LoginMetadata = async (): Promise<PrepareElisaIdV2LoginResponse> => {
  return (await callUiApi(prepareElisaIdV2LoginPublicMethod())).json();
};

export const fetchElisaIdV2LogoutMetadata = async (): Promise<ElisaIdV2LogoutResponse> => {
  return (await callUiApi(elisaIdV2LogOutPrivateMethod())).json();
};

export const fetchMfaDetails = async (): Promise<MfaDetailsResponse> => {
  return (await callUiApi(getMfaDetailsPrivateMethod())).json();
};

export const fetchSaUsers = async (saId: string): Promise<AccountKeyUsersResponse> => {
  return (await callUiApi(getAccountKeyUsersByServiceAgreementIdPrivateMethod(saId))).json();
};

export const updateSaUser = async (request: UpdateAccountKeyUserRequest) => {
  return await callUiApi(updateAccountKeyUserPrivateMethod(), { body: JSON.stringify(request) });
};

export const enableMfa = async (saId: string) => {
  return await callUiApi(enableMfaPrivateMethod(saId));
};

export const fetchNumberRange = async (rangeId: string, mdmId?: string): Promise<NumberRangeData> => {
  const res = await callUiApi(getNumberRangePrivateMethod(rangeId), { noThrow: true, mdmId });
  if (res.ok) {
    const numberResponse = await res.json();
    return getNumberRangeData(numberResponse, rangeId);
  } else if (res.status === 500 || res.status === 404) {
    // General failure, allows user to retry the loading
    return {
      rangeId: rangeId,
      errors: convertToCommonErrors(res.statusText, res.status),
    };
  } else {
    // Company possibly out of numbers
    const errors = await res.json();
    return {
      rangeId: rangeId,
      errors: convertToCommonErrors(errors[0].message, res.status, errors),
    };
  }
};

export const changeSubscriptionMobilePbx = async (
  payload: SubscriptionPbxConfiguration,
  subscriptionId: string,
  mdmId?: string
) =>
  (
    await callUiApi(changeSubscriptionMobilePbxPrivateMethod(subscriptionId), {
      body: JSON.stringify(payload),
      mdmId,
    })
  ).json();

export const changeSubscriptionFeatures = async (
  payload: SubscriptionChangeFeaturesRequest,
  subscriptionId: string,
  mdmId?: string
) =>
  (
    await callUiApi(changeSubscriptionFeaturesPrivateMethod(subscriptionId), {
      body: JSON.stringify(payload),
      mdmId,
    })
  ).json();

export const postChangeOwnerAccount = async (
  subscriptionId: string,
  request: SubscriptionChangeOwnerAccountRequest,
  mdmId?: string
) => {
  return await callUiApi(changeOwnerAccountPrivateMethod(subscriptionId), { body: JSON.stringify(request), mdmId });
};

export const fetchOmalaskuStatus = async (msisdn: string): Promise<OmalaskuStatusWithMsisdnResponse> => {
  return (await callUiApiForEmployee(getOmalaskuStatusPrivateMethod(msisdn))).json().then(responseStatus => {
    return { ...responseStatus, msisdn };
  });
};

export const activateOmalasku = async (msisdn: string, request: OmalaskuActivationRequest): Promise<boolean> => {
  const res = await callUiApiForEmployee(activateOmalaskuPrivateMethod(msisdn), {
    body: JSON.stringify(request),
    noThrow: true,
  });
  if (res.ok) {
    return true;
  } else if (res.status === 403) {
    return false;
  }
  throw res;
};

export const cancelOmalasku = async (msisdn: string): Promise<void> => {
  await callUiApiForEmployee(cancelOmalaskuPrivateMethod(msisdn));
};

export const fetchMobileIdContracts = async (): Promise<ContractsResponse> => {
  return (await callUiApi(getContractsPrivateMethod(), { useDefaultMdmId: false })).json();
};

export const fetchMobileIdContractsByMdmId = async (mdmId: string): Promise<ContractsResponse> => {
  return (await callUiApi(getContractsPrivateMethod({ mdmId }))).json();
};

export const fetchMobileIdContract = async (contractDisplayId: string): Promise<Contract> => {
  const response = await callUiApi(getContractsPrivateMethod({ contractDisplayId }), { useDefaultMdmId: false });
  const contractsResponse: ContractsResponse = await response.json();
  const mobileIdContract = contractsResponse?.contracts?.[0];
  if (!mobileIdContract) {
    throw new Response('Contract not found', { status: 404 });
  }
  return mobileIdContract;
};

export const postNewContract = async (contractType: ContractRequest.ContractTypeEnum, mdmId: string) => {
  const payload: ContractRequest = { contractType };
  return callUiApi(postContractPrivateMethod(), { body: JSON.stringify(payload), mdmId });
};

export const postTerminateContract = async (contractDisplayId: string) => {
  return callUiApi(postTerminateContractPrivateMethod(contractDisplayId));
};

export const validateMoveContact = async (
  request: MoveContactValidateRequest,
  mdmId: string
): Promise<MoveContactValidateResponse> => {
  return (
    await callUiApi(validateMoveContactPrivateMethod(), {
      body: JSON.stringify(request),
      mdmId,
    })
  ).json();
};

export const moveContact = async (request: MoveContactRequest, mdmId: string): Promise<MoveContactResponse> => {
  return (
    await callUiApi(submitMoveContactPrivateMethod(), {
      body: JSON.stringify(request),
      mdmId,
    })
  ).json();
};

export const hasPendingActionsForContact = async (
  contactMasterId: string
): Promise<MoveContactPendingActionsResponse> => {
  return (await callUiApi(hasPendingActionsForContactPrivateMethod({ contactMasterId }))).json();
};

export const fetchOnboardingRequests = async (mdmId?: string): Promise<OnboardingRequestsResponse> => {
  return (await callUiApi(getOnboardingRequestsPrivateMethod(), { mdmId, useDefaultMdmId: false })).json();
};

export const fetchInvitations = async (): Promise<Invitation[]> => {
  return (await callUiApi(listInvitationsPrivateMethod())).json();
};

export const sendEmployeeInvitations = async (employeeInvitations: EmployeeInvitation[], mdmId: string) => {
  return await callUiApi(createInvitationPrivateMethod(), {
    body: JSON.stringify({ profile: InvitationProfileEnum.CUSTOMER_EMPLOYEE, employeeInvitations }),
    noThrow: true,
    mdmId,
  });
};

export const resendInvitation = async (invitationId: string) => {
  return await callUiApi(resendInvitationPrivateMethod(invitationId), { noThrow: true });
};

export const cancelInvitation = async (invitationId: string) => {
  return await callUiApi(cancelInvitationPrivateMethod(invitationId), { noThrow: true });
};

export const hasPendingSubscriptionActions = async (subscriptionId: string, mdmId: string): Promise<boolean> => {
  if (subscriptionId.startsWith('SUB')) {
    return (
      await callUiApi(hasPendingSubscriptionActionsPrivateMethod({ subscriptionDisplayId: subscriptionId }), { mdmId })
    ).json();
  }
  return false;
};

export const fetchAvailableFixedBroadbandOffers = async (
  addressId: string,
  subscriptionType: string
): Promise<OnlineModelsResponse> => {
  return (await callUiApi(getOnlineModelsByAddressPublicMethod({ addressId, subscriptionType }))).json();
};

export const fetchPickupPoints = async (
  postalCode: string,
  service: string,
  maxResults = 10
): Promise<PickupPointSearchResponse> => {
  return (
    await callUiApi(
      searchForPickupPointPrivateMethod({
        postalCode,
        service,
        maxResults: `${maxResults}`,
      })
    )
  ).json();
};

export const fetchDeliveryMethods = async (productType?: string[]): Promise<DeliveryMethodsResponse> => {
  return (await callUiApi(getDeliveryMethodsPrivateMethod({ productType }))).json();
};

export const postEppRedeemTerminate = async (
  subscriptionId: string,
  payload: PostEppRedeemTerminateRequest,
  mdmId?: string
): Promise<void> => {
  const portal = getPortal(window.location.pathname);
  const isEmployee = portal === 'EOE' || portal === 'AuxEsim';
  const isPunchout = portal === 'Punchout';
  await callUiApi(redeemOrTerminateEppPrivateMethod(subscriptionId), {
    body: JSON.stringify(payload),
    mdmId,
    isEmployee,
    isPunchout,
  });
};

export const postEppMaintenance = async (
  subscriptionId: string,
  payload: PostEppMaintenanceRequest
): Promise<PutSupportCaseResponse> => {
  return (await callUiApi(maintenanceEppPrivateMethod(subscriptionId), { body: JSON.stringify(payload) })).json();
};

export const fetchProductOffersForOfferType = async (offerType: OfferType): Promise<ProductOfferingsResponse[]> => {
  return (await callUiApi(getEligibleProductOffersForOfferTypePublicMethod(offerType))).json();
};

export const fetchProductOffersForOfferTypeWithAddress = async (
  offerType: OfferType,
  addressId: string
): Promise<ProductOfferingsResponse[]> => {
  const method = getEligibleProductOffersForOfferTypePublicMethod(offerType);
  const separator = method.path.includes('?') ? '&' : '?';
  return (
    await callUiApi({ ...method, path: `${method.path}${separator}addressId=${encodeURIComponent(addressId)}` })
  ).json();
};

export const createProductOrder = async (payload: ProductOrderRequest): Promise<ProductOrderResponse> => {
  return (
    await callUiApi(createProductOrderPrivateMethod(), {
      body: JSON.stringify(payload),
    })
  ).json();
};

export const updateProductOrder = async (
  orderId: string,
  payload: UpdateProductOrderRequest
): Promise<ProductOrderResponse> => {
  return (
    await callUiApi(updateProductOrderPrivateMethod(orderId), {
      body: JSON.stringify(payload),
    })
  ).json();
};

export const fetchAvailableInstallationDates = async (
  orderId: string,
  payload: AvailableInstallationDatesRequestItem[]
): Promise<AvailableInstallationDatesResponseItem[]> => {
  return (
    await callUiApi(getAvailableInstallationDatesPrivateMethod(orderId), {
      body: JSON.stringify(payload),
    })
  ).json();
};

export const checkUserExists = async (
  identityCertificate: string,
  businessId: string,
  email: string
): Promise<CheckUserExistsResponse> => {
  const payload: CheckUserExistsRequest = { identityCertificate, businessId, email };
  return (await callUiApi(checkSsoUserExistsPublicMethod(), { body: JSON.stringify(payload) })).json();
};

export const postRegisterUser = async (payload: RegisterUserRequest) => {
  return await callUiApi(registerExternalAuthenticationUserPublicMethod(), { body: JSON.stringify(payload) });
};

export const validateExternalAuthUserAuthority = async (
  idServiceCode: string,
  businessId: string
): Promise<ValidateUserAuthorityResponse> => {
  const payload: ValidateUserAuthorityRequest = { idServiceCode, businessId };
  return (
    await callUiApi(validateExternalAuthenticationUserAuthorityPublicMethod(), { body: JSON.stringify(payload) })
  ).json();
};

export const postIdentifyStrongly = async (idServiceCode: string) => {
  return callUiApi(identifyStronglyPrivateMethod(), { body: JSON.stringify({ idServiceCode }), isPunchout: true });
};

export const fetchExternalAuthorizationRequest = async (linkToken: string): Promise<AuthorizationRequest> => {
  return (await callUiApi(getExternalAuthorizationRequestPublicMethod(linkToken))).json();
};

export const postExternalAuthorizationRequest = async (
  linkToken: string,
  idServiceCode: string
): Promise<AuthorizationRequest> => {
  const body = JSON.stringify({ idServiceCode });
  return (await callUiApi(authorizeExternalAuthorizationRequestPublicMethod(linkToken), { body })).json();
};

export const postReviewAsEmployer = async (reviewRequest: PostReviewRequest, isEmployee: boolean, mdmId?: string) => {
  return callUiApi(reviewAsEmployerPrivateMethod(), { body: JSON.stringify(reviewRequest), isEmployee, mdmId });
};

export const fetchProductOffersByOfferId = async (offerId: string[]): Promise<ProductOfferingsResponse[]> => {
  return (await callUiApi(getProductOffersByOfferIdPublicMethod({ offerId }))).json();
};

export const fetchCommercialAddonProductOfferings = async (
  offerId: string,
  eppOfferId?: string
): Promise<CommercialAddonProductOfferingsResponse[]> => {
  return (await callUiApi(getRelatedOffersPublicMethod(offerId, eppOfferId ? { eppOfferId } : undefined))).json();
};

export const postChangeSim = async (
  subscriptionId: string,
  payload: ChangeMobileSimParameters,
  mdmId?: string
): Promise<void> => {
  await callUiApi(changeSubscriptionChangeSimPrivateMethod(subscriptionId), { body: JSON.stringify(payload), mdmId });
};

export const fetchServiceFeeSim = async (
  resourceId: string,
  changeMobileSimParameters: ChangeMobileSimParameters,
  mdmId?: string
): Promise<ServiceFeeResponse> => {
  const payload: ServiceFeeRequest = { serviceType: 'CHANGE_SIM', resourceId, changeMobileSimParameters };
  return (await callUiApi(postServiceFeePrivateMethod(), { body: JSON.stringify(payload), mdmId })).json();
};

export interface ProposalResponseData {
  proposalResponse: ProposalResponse[];
  totalCount: number;
}

export const fetchProposals = async (
  query: LimitableQuery & { filter: string; returnTotalCount?: boolean; sort?: string }
): Promise<ProposalResponseData> => {
  const response = await callUiApi(getProposalsPrivateMethod(query));
  const payload = (await response.json()) as ProposalResponse[] | { proposalResponse?: ProposalResponse[] };
  const proposalResponse = Array.isArray(payload) ? payload : (payload.proposalResponse ?? []);
  const totalCount = response.headers.get('X-Total-Count');

  return {
    proposalResponse,
    totalCount: totalCount ? Number.parseInt(totalCount, 10) : proposalResponse.length,
  };
};

export const fetchStartBroadbandFixer = async (
  subscriptionId: string,
  locale: Locale,
  portal: string,
  mdmId?: string
): Promise<StartFixerResponse> => {
  return (await callUiApi(startBbfPrivateMethod(subscriptionId, locale, portal), { mdmId })).json();
};

export const fetchStartMobileFixer = async (
  subscriptionId: string,
  locale: Locale,
  portal: string,
  mdmId?: string
): Promise<StartFixerResponse> => {
  return (await callUiApi(startMfPrivateMethod(subscriptionId, locale, portal), { mdmId })).json();
};

export const fetchProposalByProposalId = async (proposalId: string): Promise<ProposalResponse> => {
  return (await callUiApi(getProposalByIdPrivateMethod(proposalId))).json();
};

export const submitProductOrder = async (productOrderId: string, billingAccountId?: string, transactionId?: string) => {
  const body: Record<string, unknown> = {};

  if (billingAccountId) {
    body.billingAccount = { id: billingAccountId };
  }

  if (transactionId) {
    body.transactionId = transactionId;
  }

  return (
    await callUiApi(submitProductOrderPrivateMethod(productOrderId), {
      body: JSON.stringify(body),
    })
  ).json();
};

export const fetchProductDeliveryMethods = async (
  orderId?: string,
  offset?: number,
  limit?: number
): Promise<DeliveryMethodGroup[]> => {
  const query: { filter?: string; offset?: number; limit?: number } = {};

  if (orderId) {
    query.filter = `productOrder.id=="${orderId}"`;
  }

  if (typeof offset === 'number') {
    query.offset = offset;
  }

  if (typeof limit === 'number') {
    query.limit = limit;
  }

  const method =
    Object.keys(query).length === 0
      ? getProductDeliveryMethodsPrivateMethod()
      : getProductDeliveryMethodsPrivateMethod(query as LimitableQuery);
  return (await callUiApi(method)).json();
};

export const fetchDeliveryOptions = async (orderId: string, addressId: string): Promise<DeliveryOptionsResponse> => {
  return (await callUiApi(getDeliveryOptionsPrivateMethod(orderId, { addressId }))).json();
};

export const fetchCustomer = async (mdmId?: string): Promise<CustomerResponse> => {
  return (await callUiApi(getCustomerPrivateMethod(), mdmId ? { mdmId } : undefined)).json();
};

export const createOnlineOrder = async (onlineOrder: Partial<OnlineOrder>): Promise<PostOnlineOrderResponse> => {
  return (
    await callUiApi(createOnlineOrderPrivateMethod(), {
      body: JSON.stringify({ onlineOrder }),
    })
  ).json();
};

export const searchGeographicAddress = async (searchText: string, postCode: string): Promise<GeographicAddress[]> => {
  return (await callUiApi(getGeographicAddressPrivateMethod({ postCode, query: searchText }))).json();
};

export const fetchGeographicAddressById = async (addressId: string): Promise<GeographicAddress> => {
  return (await callUiApi(getGeographicAddressByIdPrivateMethod(addressId))).json();
};

export const updateProductOrderDeliveryMethod = async (
  payload: ProductOrderDeliveryMethodRequest,
  orderId: string
): Promise<ProductOrderDeliveryMethodResponse> => {
  return (
    await callUiApi(updateProductOrderDeliveryMethodPrivateMethod(orderId), { body: JSON.stringify(payload) })
  ).json();
};

export const updateProposalByProposalId = async (
  proposalId: string,
  payload: UpdateProposalRequest
): Promise<UpdateProposalResponse> => {
  return (await callUiApi(updateProposalByIdPrivateMethod(proposalId), { body: JSON.stringify(payload) })).json();
};

export const fetchDeviceOffersForOfferType = async (
  offerType: OfferType,
  query?: { brand?: string; priceRange?: string },
  opts?: { origin?: string }
): Promise<ProductOfferingsResponse[]> => {
  const apiCall = getEligibleProductOffersForOfferTypePublicMethod(offerType, query);
  if (opts?.origin && apiCall.path.startsWith('/')) {
    apiCall.path = `${opts.origin}${apiCall.path}`;
  }
  return (await callUiApi(apiCall)).json();
};

export const fetchDeviceVariants = async (
  deviceType: DeviceVariantProductTypeCoCo,
  query: { category: string; sort?: string }
): Promise<DeviceVariantGroup[]> => {
  return (await callUiApi(getDeviceVariantsPrivateMethod(deviceType, query))).json();
};

export const fetchProductOfferByOfferId = async (
  offerId: string,
  opts?: { origin?: string }
): Promise<ProductOfferingsResponse> => {
  const apiCall = getProductOfferingByIdPublicMethod(offerId);
  const method =
    opts?.origin && apiCall.path.startsWith('/') ? { ...apiCall, path: `${opts.origin}${apiCall.path}` } : apiCall;
  return (await callUiApi(method)).json();
};

export const initiateCardPaymentForDeviceOrder = async (orderId: string): Promise<InitCardPaymentResponse> => {
  return (await callUiApi(initCardPaymentForProductOrderPrivateMethod(orderId))).json();
};
